import React from 'react';
import PropTypes from 'prop-types';
import { MOTIVATOR_ICONS_FILLED_SVG } from 'constants/scales';
import './styles.scss';

const MotivatorIcon = ({ textColor, motivatorText }) => {
    return (
        <div className='motivator-icon'>
            <div className='motivator-icon-container' style={ { border: `1px solid ${ textColor }` } }>
                <img src={ MOTIVATOR_ICONS_FILLED_SVG[`${ motivatorText }_filled_svg`] } alt='motivator-icon' />
            </div>
        </div>
    );
};

MotivatorIcon.propTypes = {
    textColor: PropTypes.string,
    motivatorText: PropTypes.string
};

export default MotivatorIcon;
